module.exports = __webpack_public_path__ + "img/close_w.4c47c0fa.svg";